/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../../utils/apiClient';
import { restructureRoomModel, restructureMessageModel } from './restructuring';
import { restructurePaginationModel } from '../../../../common/restructuring';

class MessengerService {
  async createRoom(state, data) {
    const response = await api.post('/messenger/create-group-room', {}, data);
    const responseJson = await response.json();
    return {
      response: responseJson,
      destructData: null
    };
  }

  async editRoom(state, roomUuid, data) {
    const response = await api.put(
      `/messenger/edit-room/${roomUuid}`,
      {},
      data
    );
    const responseJson = await response.json();
    return {
      response: responseJson,
      destructData: {
        itemsById: _.keyBy(
          _.map(responseJson.data, item =>
            restructureMessageModel(state, item)
          ),
          'id'
        ),
        itemsIds: _.map(responseJson.data, item => item.id)
      }
    };
  }

  async getMeRooms(state, queryParams) {
    const response = await api.get(`/messenger/get-me-rooms`, {
      expand: 'viewedMembers',
      ...queryParams
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        itemsById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureRoomModel(state, item)
          ),
          'id'
        ),
        itemsIds: _.map(responseJson.data.items, item => item.id),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        )
      }
    };
  }

  async getUserRoomByUuid(state, roomUuid) {
    const response = await api.get(`/messenger/get-room/${roomUuid}`, {
      expand: 'members.profile,publicMemberRooms'
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        itemsById: _.keyBy(
          _.map([responseJson.data], item => restructureRoomModel(state, item)),
          'roomUuid'
        )
      }
    };
  }

  async getMessagesFromUserRoom(state, roomUuid, queryParams) {
    const response = await api.get(
      `/messenger/get-messages-from-my-room/${roomUuid}`,
      queryParams
    );
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        itemsById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureMessageModel(state, item)
          ),
          'id'
        ),
        itemsIds: _.map(responseJson.data.items, item => item.id),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        )
      }
    };
  }

  async sendMessage(state, roomUuid, data) {
    const response = await api.post(
      `/messenger/send-message/${roomUuid}`,
      {},
      data
    );
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        itemId: responseJson.data.id,
        item: restructureMessageModel(state, responseJson.data)
      }
    };
  }

  async getPrivateRoom(state, userId) {
    const response = await api.get(`/messenger/get-private-room/${userId}`);
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: restructureRoomModel(state, responseJson.data)
    };
  }

  async personalUniversalSearch(state, queryParams) {
    const response = await api.get('/messenger/personal-universal-search', {
      expand: 'userRoom',
      ...queryParams
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        itemsById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureMessageModel(state, item)
          ),
          'id'
        ),
        itemsIds: _.map(responseJson.data.items, item => item.id),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        )
      }
    };
  }

  async getLastViewedMessagesByUsers(state, roomUuid) {
    const response = await api.get(
      `/messenger/get-last-viewed-messages-by-users/${roomUuid}`
    );
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: responseJson.data
    };
  }

  async getMeStat() {
    const response = await api.get(`/messenger/me-stat`);
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: responseJson.data
    };
  }

  async leaveGroupRoom(state, roomUuid) {
    const response = await api.post(`/messenger/leave-group-room/${roomUuid}`);
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: responseJson.data
    };
  }
}

export default new MessengerService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/messenger/services/MessengerService/MessengerService.js